import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'fuse-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss']
})
export class FuseConfirmDialogComponent {
    public confirmMessage: string;
    public title: string = 'Confirm';
    public confirmButtonText: string = 'Confirm';
    public cancelButtonText: string = 'Cancel';


    /**
     * Constructor
     *
     * @param {MatDialogRef<FuseConfirmDialogComponent>} dialogRef
     */
    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<FuseConfirmDialogComponent>,
        private _translateService: TranslateService,

    ) {
        if (data) {
            this._translateService.get(data.confirmMessage, data.interpolateParams).subscribe(msg => this.confirmMessage = msg);

            this._translateService.get(data.title).subscribe(msg => this.title = msg);

            this._translateService.get(data.confirmButtonText).subscribe(msg => this.confirmButtonText = msg);

            this._translateService.get(data.cancelButtonText).subscribe(msg => this.cancelButtonText = msg);
        }
    }

}
